import Axios from 'axios'
import React, {useState, useEffect, useContext} from 'react'
import { useParams } from 'react-router-dom'
import { getPlayerApi } from '../api/api_football'
import PlayerStatsAPI from '../components/Public/FootballAPI/Player/PlayerStatsAPI'
import AddUtenlandsProff from '../components/Public/FootballAPI/Player/templates/AddUtenlandsProff'
import ViewJarallaxPlayer from '../components/Public/FootballAPI/View/ViewJarallaxPlayer'
import { config } from '../config/config'
import StateContext from '../StateContext'

function SinglePlayerAPIPage() {

    const {id} = useParams()

    const {loggedIn, userId} = useContext(StateContext)

    const [player, setPlayer] = useState()
    const [seasonStats, setSeasonStats] = useState()
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {

        async function fetchPlayer() {

            setIsLoading(true)

            try {
                const data = await getPlayerApi(id)
                setSeasonStats(data)
                setPlayer(data[0])
            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)

        }
        fetchPlayer()

    }, [id])

    return (
        <div>
            <ViewJarallaxPlayer 
               draktnummer={player?.number || 99} 
               posisjon={player?.position} 
               age={player?.age} 
               text={player?.player_name} 
               birthPlace={player?.birth_place}
            />
            {loggedIn && config.admin_user_ids.includes(userId) && <AddUtenlandsProff player={player} />}
            {seasonStats && (
                <PlayerStatsAPI seasonStats={seasonStats} />
            )}
            
        </div>
    )
}
export default SinglePlayerAPIPage